import type { ContextMenuInterface } from './types';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const initialState: ContextMenuInterface = {
  showContextMenu: false,
  unitContextMenu: null,
  connectionContextMenu: null,
};

const contextMenuSlice = createSlice({
  name: 'contextMenu',
  initialState,
  reducers: {
    setShowContextMenu(state, action: PayloadAction<boolean>) {
      state.showContextMenu = action.payload;
      state.unitContextMenu = null;
      state.connectionContextMenu = null;
    },
    setShowUnitContextMenu(state, action: PayloadAction<string | null>) {
      state.showContextMenu = false;
      state.unitContextMenu = action.payload;
      state.connectionContextMenu = null;
    },
    setShowConnectionContextMenu(state, action: PayloadAction<string | null>) {
      state.unitContextMenu = null;
      state.showContextMenu = false;
      state.connectionContextMenu = action.payload;
    },
  },
});

export const {
  setShowContextMenu,
  setShowUnitContextMenu,
  setShowConnectionContextMenu,
} = contextMenuSlice.actions;

export const contextMenuReducer = contextMenuSlice.reducer;
